import { GenericResponse, TableRequestV3, TableResponse } from 'services/types'
import { employeeApi } from './employee'
import { AddLeaveRequest, AddLeaveResponse, EmployeeBaseSearchRequest } from './types'
import { DropdownOptionTemplate } from 'types/common'

const leaveApi = employeeApi.injectEndpoints({
  endpoints: (build) => ({
    addLeave: build.mutation<AddLeaveResponse, AddLeaveRequest>({
      query: ({ clientId, ...data }) => ({
        url: `clients/${clientId}/leave/`,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Leaves'],
    }),
    getLeaveList: build.query<TableResponse<{}>, TableRequestV3 & { employeeId?: string }>({
      query: ({ clientId, employeeId, ...data }) => ({
        url: `clients/${clientId}/leave/list/`,
        params: {
          employee_id: employeeId,
        },
        method: 'POST',
        data,
      }),
      providesTags: ['Leaves'],
    }),
    searchLeave: build.query<
      GenericResponse & { leave_list: DropdownOptionTemplate<string> },
      EmployeeBaseSearchRequest
    >({
      query: ({ clientId, searchParam, employeeId, exact }) => ({
        url: `clients/${clientId}/leave/search/`,
        method: 'GET',
        params: {
          search_param: searchParam,
          employee_id: employeeId,
          exact,
        },
      }),
    }),
    updateLeave: build.mutation<
      AddLeaveResponse,
      {
        clientId: string
        leaveId: string
        note: string
      }
    >({
      query: ({ clientId, leaveId, ...data }) => ({
        url: `clients/${clientId}/leave/${leaveId}/`,
        method: 'PATCH',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Leaves'],
    }),
  }),
})

export const {
  useAddLeaveMutation,
  useGetLeaveListQuery,
  useUpdateLeaveMutation,
  useLazySearchLeaveQuery,
} = leaveApi
